import { extendsModule, baseFormItem } from 'src/store/base';
import * as types from 'src/store/types';

// 应用的展示名称字段是app_name，落地页是source
export default extendsModule(baseFormItem, {
  state: {
    _moduleKey: 'procedural-creative-app-name',
    app_name: '',
    source: '',
  },
  getters: {
    formItemData(state) {
      return {
        app_name: state.app_name,
        source: state.source,
      };
    },
  },
  mutations: {
    [types.UPDATE_PCD_APP_NAME](state, name = '') {
      state.app_name = name;
    },
    [types.UPDATE_PCD_SOURCE](state, name = '') {
      state.source = name;
    },
  },
  actions: {
    data2State({ commit }, formData) {
      const data = {
        app_name: formData.app_name || '',
        source: formData.source || '',
      };
      // 在编辑、复制、use exist新建时，如果后端返回的创意名称是空的，则需要再次勾选checkbox
      // 使用setPcdAdByCreativeDetail方法时，会设置resetAutoName，其余情况默认false
      commit('update', data);
    },
  },
});
